import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Dictionary } from "src/app/store/models/common_types";
import { Observable } from "rxjs";
import { AppService } from "../app.service";

@Injectable({
  providedIn: "root",
})
export class RightPanelService {
  constructor(
    private http: HttpClient,
    private appServie: AppService,
  ) {}
  apiUrl: string = window.apiUrl;

  getRightPanelDimensions = (pg: string, cut: string, ticker: string) => {
    return this.http.get(
      `${this.apiUrl}/api/get_other_dim_meta?pg=${pg}&cut=${cut}&ticker=${ticker}`,
    );
  };

  getPeriodsMeta = (pg: string, cut: string, ticker: string) => {
    return this.http.get(
      `${this.apiUrl}/api/get_period_meta?pg=${pg}&cut=${cut}&ticker=${ticker}`,
    );
  };

  getSourcePanelMeta = (
    ticker: string,
    pageName: string,
    isClear?: boolean,
  ) => {
    let url: Observable<Record<string, any>> = null;
    switch (pageName) {
      case "revisions":
        url = this.http.get(
          `${this.apiUrl}/api/get_rev_dashboard_default_meta/?ticker=${ticker}&isClear=${isClear}`,
        );
        break;
      case "surprise":
        url = this.http.get(
          `${this.apiUrl}/api/get_surprise_dashboard_default_meta/?ticker=${ticker}&isClear=${isClear}`,
        );
        break;
      default:
        break;
    }
    return url;
  };

  applyDefaultSetting(deleteHistoryObj) {
    return this.http.post(
      `${this.apiUrl}/api/deletegridpanelshistory/`,
      deleteHistoryObj,
    );
  }

  saveAppliedSettingForSourcePanel = (
    ticker: string,
    postObj: Dictionary<any>,
    pageName: string,
  ) => {
    let url: Observable<Record<string, any>> = null;
    switch (pageName) {
      case "revisions":
        url = this.http.post(
          `${this.apiUrl}/api/revision_dashboard_history/?ticker=${ticker}`,
          postObj,
        );
        break;
      case "surprise":
        url = this.http.post(
          `${this.apiUrl}/api/surprise_dashboard_history/?ticker=${ticker}`,
          postObj,
        );
        break;
      case "mex":
        url = this.http.post(`${this.apiUrl}/api/gridpanelshistory/`, postObj);
        break;
      default:
        break;
    }
    return url;
  };

  deleteRightPanelPresets = (ticker: string) => {
    const deldata = {
      company: ticker,
      cut: null,
      source: null,
      jsonData: {},
      dimension: "",
    };

    return this.http.post(`${this.apiUrl}/api/deletegridpanelshistory/`, {
      viewdata: deldata,
    });
  };
}
